import { Component, OnInit } from '@angular/core';
import { GlobalFunctionsService } from './../../services/global-functions.service';

@Component({
  selector: 'app-client-users',
  templateUrl: './client-users.component.html',
  styleUrls: ['./client-users.component.css']
})
export class ClientUsersComponent implements OnInit {

  constructor(public gfunc: GlobalFunctionsService) {

  }

  ngOnInit() {
  }

}
